export default __webpack_public_path__ + "static/sand-13359b95dcf408e9fdeaee9c35bb78a6.png";